import React, { useEffect, useState } from "react";
import { tint, transparentize } from "polished";
import styled from "styled-components";
import * as Clrs from "../js/colors";

import p1 from "../images/optimized/anUnmarkedPlace.jpg";
import p2 from "../images/optimized/thisTooShallPass.jpg";
import p3 from "../images/optimized/weatherWorry.jpg";
import p4 from "../images/optimized/theRoadToNowhere.jpg";
import p5 from "../images/optimized/height.jpg";
import p6 from "../images/optimized/coldQuietDark.jpg";
import p7 from "../images/optimized/beforeFalling.jpg";
import p8 from "../images/optimized/contractOfLand.jpg";
import p9 from "../images/optimized/theyFlutterBehindYou.jpg";
import p10 from "../images/optimized/pivots.jpg";
import p11 from "../images/optimized/rocks.jpg";
import p12 from "../images/optimized/alteredLandscape.jpg";
import p13 from "../images/optimized/falling.jpg";
import p14 from "../images/optimized/grove.jpg";
import p15 from "../images/optimized/masTequila.jpg";
import p16 from "../images/optimized/sunflower.jpg";
import p17 from "../images/optimized/sunflowers2.jpg";
import p18 from "../images/optimized/itsSuchADrag.jpg";
import p19 from "../images/optimized/nowayout.jpg";
import p20 from "../images/optimized/oldhead.jpg";
import p21 from "../images/optimized/theGreenJacket.jpg";
import p22 from "../images/optimized/fjordOfSorts.jpg";
import p23 from "../images/optimized/Somewhere-Up-North.jpg";
import p24 from "../images/optimized/untitled2.jpg";
import p25 from "../images/optimized/theIowa.jpg";
import p26 from "../images/optimized/natureswall.jpg";
import p27 from "../images/optimized/natureswall2.jpg";
import p29 from "../images/optimized/couldyoubemine.jpg";
import p30 from "../images/optimized/self2.jpg";
import p31 from "../images/optimized/crofts.jpg";
import p32 from "../images/optimized/takeawalk.jpg";
import p33 from "../images/optimized/natureswall3.jpg";
import p34 from "../images/optimized/winterscene.jpg";
import p35 from "../images/optimized/tiger.jpg";
import p36 from "../images/optimized/newLife1.jpg";
import p37 from "../images/optimized/newLife2.jpg";
import p38 from "../images/optimized/newLife3.jpg";

const railAndCarouselBg = tint(0.8, Clrs.basegrey);
const mainAreaBg = tint(0.9, Clrs.basegrey);
const carouselSurfaceBg = transparentize(0.7, railAndCarouselBg);
const metadataSurfaceBg = transparentize(0.6, Clrs.white);
const soldOliveBg = "#4f5f2f";

const portfolioItems = [
  {
    src: p38,
    title: "New Life #3",
    year: "2025",
    description: 'Oil on canvas, 48" x 46"',
    sold: false,
  },
  { src: p37, title: "New Life #2", year: "2025", description: "Oil on canvas", sold: false },
  { src: p36, title: "New Life #1", year: "2025", description: "Oil on canvas", sold: true },
  { src: p30, title: "Untitled", year: "2023", description: "Oil on canvas board" },
  { src: p31, title: "The Crofts", year: "2023", description: "Oil on canvas board" },
  { src: p33, title: "Nature's Wall 3", year: "2022", description: "Oil on canvas board", sold: true },
  { src: p32, title: "We Take a Walk...", year: "2022", description: "Oil on canvas board" },
  {
    src: p29,
    title: "Could You Be Mine?",
    year: "2022",
    description: 'Oil on canvas board, 60" x 28"',
  },
  { src: p34, title: "Untitled", year: "2022", description: "Oil on canvas board" },
  { src: p25, title: "The Iowa", year: "2021", description: "Oil on canvas board", sold: true },
  { src: p26, title: "Nature's Wall #1", year: "2021", description: "Oil on canvas board", sold: true },
  { src: p27, title: "Nature's Wall #2", year: "2021", description: "Oil on canvas board", sold: true },
  { src: p16, title: "Sentinel", year: "2019", description: "Oil on canvas board" },
  { src: p17, title: "A Solemn Gathering", year: "2019", description: "Oil on panel", sold: true },
  { src: p20, title: "18 at Oldhead", year: "2019", description: "Oil on canvas", sold: true },
  { src: p21, title: "The Green Jacket", year: "2019", description: "Oil on canvas board" },
  { src: p2, title: "This Too Shall Pass", year: "2018", description: "Oil on canvas", sold: true },
  { src: p35, title: "Untitled", year: "2018", description: "Oil on canvas", sold: true },
  { src: p9, title: "They Flutter Behind You", year: "2018", description: '72" x 48" | Oil on canvas' },
  { src: p23, title: "Somewhere Up North", year: "2018", description: "Oil on canvas", sold: true },
  { src: p1, title: "An Unmarked Place", year: "2017", description: "Oil on canvas", sold: true },
  { src: p3, title: "Weather; Worry", year: "2017", description: "Oil on canvas", sold: true },
  { src: p4, title: "The Road to Nowhere", year: "2017", description: "Oil on canvas" },
  { src: p18, title: "It's Such a Drag", year: "2017", description: "Oil on canvas" },
  { src: p24, title: "Untitled", year: "2017", description: "Oil on canvas" },
  { src: p19, title: "There's No Way Out of Here", year: "2017", description: "Oil on canvas" },
  { src: p5, title: "Height", year: "2016", description: "Oil on canvas" },
  { src: p6, title: "Cold, Quiet & Dark", year: "2016", description: "Oil on canvas" },
  { src: p7, title: "Before Falling", year: "2016", description: "Oil on canvas" },
  { src: p8, title: "A Contract of Land", year: "2016", description: "Oil on canvas", sold: true },
  { src: p10, title: "Pivots", year: "2016", description: "Oil on canvas", sold: true },
  {
    src: p11,
    title: "The Rocks Slowed Our Descent",
    year: "2016",
    description: "Oil on canvas",
  },
  { src: p12, title: "Altered Landscape", year: "2016", description: "Oil on canvas", sold: true },
  { src: p13, title: "Falling", year: "2015", description: "Oil on canvas", sold: true },
  { src: p14, title: "Grove", year: "2015", description: "Oil on canvas" },
  { src: p15, title: "Mas Tequila", year: "2015", description: 'Oil on canvas, 36" x 36"', sold: true },
  { src: p22, title: "Fjord of Sorts", year: "Archive", description: "Oil study" },
];

function Paintings({ onBackgroundChange }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeItem = portfolioItems[activeIndex];
  const firstIndexByYear = portfolioItems.reduce((accumulator, item, index) => {
    if (accumulator[item.year] === undefined) {
      accumulator[item.year] = index;
    }

    return accumulator;
  }, {});
  const timelineYears = Object.keys(firstIndexByYear);

  useEffect(() => {
    if (onBackgroundChange) {
      onBackgroundChange(activeItem.src);
    }
  }, [activeItem.src, onBackgroundChange]);

  function goToIndex(nextIndex) {
    const itemCount = portfolioItems.length;
    const wrappedIndex = (nextIndex + itemCount) % itemCount;
    setActiveIndex(wrappedIndex);
  }

  function goPrev() {
    goToIndex(activeIndex - 1);
  }

  function goNext() {
    goToIndex(activeIndex + 1);
  }

  return (
    <CarouselPage>
      <HeroContainer>
        <ArrowButton type="button" aria-label="Previous image" left onClick={goPrev}>
          <ArrowMark>&#8249;</ArrowMark>
        </ArrowButton>

        <HeroViewport>
          <HeroTrack style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
            {portfolioItems.map((item) => (
              <HeroSlide key={`${item.title}-${item.src}`}>
                <HeroImage src={item.src} alt={item.title} />
              </HeroSlide>
            ))}
          </HeroTrack>
        </HeroViewport>

        <ArrowButton type="button" aria-label="Next image" onClick={goNext}>
          <ArrowMark>&#8250;</ArrowMark>
        </ArrowButton>
      </HeroContainer>

      <MetaRow>
        <ImageMeta>
          <ImageTitle>{activeItem.title}</ImageTitle>
          <ImageDetails>
            {activeItem.year} | {activeItem.description}
          </ImageDetails>
        </ImageMeta>
        {activeItem.sold ? <SoldBadge>Sold</SoldBadge> : null}
      </MetaRow>

      <ThumbRail>
        <Timeline aria-label="Artwork timeline">
          {timelineYears.map((year, index) => (
            <TimelineItem key={`${year}-${index}`} $start={firstIndexByYear[year]}>
              <TimelineTick />
              <TimelineYear>{year}</TimelineYear>
            </TimelineItem>
          ))}
        </Timeline>

        <ThumbStrip>
          {portfolioItems.map((item, index) => (
            <ThumbButton
              key={`thumb-${item.title}-${item.src}`}
              type="button"
              className={index === activeIndex ? "active" : ""}
              aria-label={`View ${item.title}`}
              aria-current={index === activeIndex ? "true" : "false"}
              onClick={() => goToIndex(index)}
            >
              <ThumbImage src={item.src} alt={item.title} />
            </ThumbButton>
          ))}
        </ThumbStrip>
      </ThumbRail>
    </CarouselPage>
  );
}

const CarouselPage = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 12px 44px;
  font-family: Helvetica, Arial, sans-serif;
  --timeline-step: 84px;
  --timeline-gap: 6px;

  @media (max-width: 980px) {
    padding: 0 8px 24px;
    --timeline-step: 72px;
    --timeline-gap: 5px;
  }

  @media (max-width: 640px) {
    --timeline-step: 62px;
    --timeline-gap: 4px;
  }
`;

const HeroContainer = styled.div`
  position: relative;
`;

const HeroViewport = styled.div`
  overflow: hidden;
  border-radius: 0;
  background: ${carouselSurfaceBg};
`;

const HeroTrack = styled.div`
  display: flex;
  transition: transform 420ms ease;
  will-change: transform;
`;

const HeroSlide = styled.div`
  min-width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${carouselSurfaceBg};

  @media (max-width: 980px) {
    aspect-ratio: 5 / 4;
  }

  @media (max-width: 640px) {
    aspect-ratio: 1 / 1;
  }
`;

const HeroImage = styled.img`
  width: auto;
  height: auto;
  max-width: 95%;
  max-height: 95%;
  display: block;
  object-fit: contain;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  ${(props) => (props.left ? "left: 0;" : "right: 0;")}
  transform: translateY(-50%);
  z-index: 2;
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 0;
  cursor: pointer;
  display: grid;
  place-items: center;
  color: ${Clrs.basegrey};
  background: ${mainAreaBg};
  transition: background 180ms ease, transform 180ms ease;

  &:hover {
    background: ${tint(0.86, Clrs.basegrey)};
    transform: translateY(-50%) scale(1.05);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  @media (max-width: 980px) {
    width: 40px;
    height: 40px;
  }
`;

const ArrowMark = styled.span`
  font-size: 34px;
  line-height: 1;

  @media (max-width: 980px) {
    font-size: 28px;
  }
`;

const MetaRow = styled.div`
  margin-top: 0;
  margin-bottom: 16px;
  display: inline-flex;
  align-items: stretch;

  @media (max-width: 980px) {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 12px;
  }
`;

const ImageMeta = styled.div`
  display: block;
  padding: 10px 12px;
  background: ${metadataSurfaceBg};

  @media (max-width: 980px) {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
  }
`;

const SoldBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  padding: 4px 3px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${Clrs.white};
  background: ${soldOliveBg};
`;

const ImageTitle = styled.h2`
  margin: 0;
  color: ${Clrs.basegrey};
  font-size: 22px;

  @media (max-width: 980px) {
    font-size: 18px;
  }
`;

const ImageDetails = styled.p`
  margin: 6px 0 0;
  color: ${Clrs.grey};
  font-size: 14px;

  @media (max-width: 980px) {
    font-size: 13px;
    line-height: 1.4;
  }
`;

const Timeline = styled.div`
  position: relative;
  width: calc(
    (${portfolioItems.length} * var(--timeline-step)) +
      ((${portfolioItems.length} - 1) * var(--timeline-gap))
  );
  height: 44px;
  margin: 0 0 -10px;
  padding: 7px 2px 0;
  border-top: 1px solid ${Clrs.basegrey};

  @media (max-width: 640px) {
    height: 40px;
    margin-bottom: -12px;
  }
`;

const TimelineItem = styled.div`
  position: absolute;
  top: 0;
  left: ${(props) => `calc(${props.$start} * (var(--timeline-step) + var(--timeline-gap)))`};
  width: var(--timeline-step);
  height: 100%;
  color: ${Clrs.basegrey};
`;

const TimelineTick = styled.span`
  position: absolute;
  top: 0;
  left: 2px;
  width: 1px;
  height: 14px;
  background: ${Clrs.basegrey};
  opacity: 0.7;
`;

const TimelineYear = styled.span`
  position: absolute;
  left: 6px;
  top: 12px;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.06em;
  transform: rotate(45deg);
  transform-origin: left top;
  white-space: nowrap;

  @media (max-width: 640px) {
    top: 11px;
    left: 5px;
    font-size: 9px;
  }
`;

const ThumbRail = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 6px;

  &::-webkit-scrollbar {
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #4b5962;
    border-radius: 8px;
  }
`;

const ThumbStrip = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: var(--timeline-step);
  gap: var(--timeline-gap);
  width: max-content;
`;

const ThumbButton = styled.button`
  padding: 0;
  border: 2px solid ${Clrs.white};
  border-radius: 0;
  cursor: pointer;
  overflow: hidden;
  background: #11181d;
  transition: border-color 180ms ease, transform 180ms ease, opacity 180ms ease;
  opacity: 0.72;

  &.active {
    border-color: ${Clrs.brightgreen};
    opacity: 1;
    transform: translateY(-1px);
  }

  &:hover {
    opacity: 1;
  }

  &:focus-visible {
    outline: none;
    border-color: #ffffff;
    opacity: 1;
  }
`;

const ThumbImage = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  height: auto;
  object-fit: cover;
  display: block;
`;

export { Paintings };
